// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"76e3f5a2","438":"f1585f99","450":"a3ab4b13","505":"89f2b8a5","630":"2b018b8a","750":"972e62c0","937":"14bf6daf","972":"53b16521","995":"14bf6daf"}[chunkId] + ".chunk.css";
};